import Layout from '@/layout'

const events = {
  path: '/events',
  name: 'MyEvents',
  component: Layout,
  title: '我的事务',
  redirect: '/events/graduation',
  meta: { title: '办理毕业生事务', name: 'MyEvents' },
  children: [
    {
      path: 'graduation',
      name: 'Graduation',
      component: () => import('@/views/MyEvents/graduation/index.vue'),
      meta: { title: '办理毕业生事务' }
    }
  ]
}

export default events
